module.exports = __webpack_public_path__ + "static/media/perio.7fcdb4f8.svg";